import React from "react"; // eslint-disable-line no-unused-vars
import Modal from "../../components/Modal";
import TextArea from "../../components/TextArea";

function CrewMetaModal({ currentCrew, setOpenCrewMetaModal }) {

  // - - - - - - - - - -

  const onClose = () => {
    setOpenCrewMetaModal({ show: false });
  };

  // - - - - - - - - - -

  return (
    <Modal onClose={() => onClose()}>
      <Modal.Header>
        <div className="flex justify-between">
          <div>Crew Schedule Notes</div>
        </div>
      </Modal.Header>
      <Modal.Content>
        <div className="flex flex-col gap-4 w-[400px]">
          <div className="text-lg font-bold">{currentCrew?.Name_Full}</div>
          <div className="flex flex-col gap-1 p-2 bg-skin-surface-hard">
            <div>
              <TextArea
                readOnly={true}
                placeholder="Custom Notes"
                rows={20}
                value={currentCrew?.SchedulerNotes}
                className="bg-skin-base border border-black/20 "
              ></TextArea>
            </div>
          </div>
          <div></div>
        </div>
      </Modal.Content>
    </Modal>
  );
}

export default CrewMetaModal;
